import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface SearchState {
  isOpen: boolean
  query: string
  recentSearches: string[]
  selectedIndex: number
  open: () => void
  close: () => void
  toggle: () => void
  setQuery: (query: string) => void
  setSelectedIndex: (index: number) => void
  addRecentSearch: (query: string) => void
  clearRecentSearches: () => void
}

const MAX_RECENT_SEARCHES = 5

export const useSearchStore = create<SearchState>()(
  persist(
    (set) => ({
      isOpen: false,
      query: '',
      recentSearches: [],
      selectedIndex: -1,
      open: () => set((state) => state.isOpen ? {} : { isOpen: true, query: '', selectedIndex: -1 }),
      close: () => set({ isOpen: false, query: '', selectedIndex: -1 }),
      toggle: () => set((state) => ({
        isOpen: !state.isOpen,
        query: state.isOpen ? '' : state.query,
        selectedIndex: -1,
      })),
      setQuery: (query: string) => set({ query, selectedIndex: -1 }),
      setSelectedIndex: (index: number) => set({ selectedIndex: index }),
      addRecentSearch: (query: string) =>
        set((state) => {
          const filtered = state.recentSearches.filter((s) => s !== query)
          return {
            recentSearches: [query, ...filtered].slice(0, MAX_RECENT_SEARCHES),
          }
        }),
      clearRecentSearches: () => set({ recentSearches: [] }),
    }),
    {
      name: 'flowrent-search',
      partialize: (state) => ({ recentSearches: state.recentSearches }),
    }
  )
)
